import { render, staticRenderFns } from "./ProductDescriptions.vue?vue&type=template&id=34607166"
import script from "./ProductDescriptions.vue?vue&type=script&lang=js"
export * from "./ProductDescriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports